import type { ReactNode } from 'react';

export const symbol_network_wifi_1_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M344-338q28.57-23.21 63.43-36.11Q442.29-387 480-387q37.71 0 72.57 12.89Q587.43-361.21 616-338l256-256q-87-68-184.5-107T480-740q-110 0-207.5 39T88-594l256 256Zm94 176L47-553q-9-9.08-13.5-20.43T29-596.14q0-12.86 5.5-24.76Q40-632.79 51-642q91-76 200.5-117T480-800q119 0 228.5 41T909-642q11 9.12 16.5 20.9t5.5 24.7q0 11.4-4.5 22.83Q922-562.14 913-553L522-162q-9 9-20 13t-22 4q-11 0-22-4t-20-13Z"
		/>
	</svg>
);
